import { GroupId } from '../../typings/groups';
import { Feeds } from '../../typings/groupsEditState';

export const PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED =
    'PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED';
export type PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED = typeof PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED;

export interface SetVisibleGroupBannerPopupFeedAction {
    type: PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED;
    groupId: GroupId;
    isVisible: boolean;
}

export function setVisibleGroupBannerPopupFeed(
    groupId: GroupId,
    isVisible: boolean
): SetVisibleGroupBannerPopupFeedAction {
    return {
        type: PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED,
        groupId,
        isVisible
    };
}

export const PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT =
    'PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT';
export type PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT = typeof PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT;

export interface ChangeBannerFeedSearchTextAction {
    type: PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT;
    groupId: GroupId;
    value: string;
}

export function changeBannerFeedSearchText(
    groupId: GroupId,
    value: string
): ChangeBannerFeedSearchTextAction {
    return {
        type: PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT,
        groupId,
        value
    };
}

export const PERFORMANCE_SUGGEST_FEED_ITEM_CLICK =
    'PERFORMANCE_SUGGEST_FEED_ITEM_CLICK';
export type PERFORMANCE_SUGGEST_FEED_ITEM_CLICK = typeof PERFORMANCE_SUGGEST_FEED_ITEM_CLICK;

export interface SuggestFeedItemClickAction {
    type: PERFORMANCE_SUGGEST_FEED_ITEM_CLICK;
    groupId: GroupId;
    feedId: string;
}

export function suggestFeedItemClick(
    groupId: GroupId,
    feedId: string
): SuggestFeedItemClickAction {
    return {
        type: PERFORMANCE_SUGGEST_FEED_ITEM_CLICK,
        groupId,
        feedId
    };
}

export const PERFORMANCE_SET_VISIBLE_FEED_MODAL =
    'PERFORMANCE_SET_VISIBLE_FEED_MODAL';
export type PERFORMANCE_SET_VISIBLE_FEED_MODAL = typeof PERFORMANCE_SET_VISIBLE_FEED_MODAL;

export interface SetVisibleFeedModalAction {
    type: PERFORMANCE_SET_VISIBLE_FEED_MODAL;
    isVisible: boolean;
}

export function setVisibleFeedModal(
    isVisible: boolean
): SetVisibleFeedModalAction {
    return {
        type: PERFORMANCE_SET_VISIBLE_FEED_MODAL,
        isVisible
    };
}

export const PERFORMANCE_UPDATE_FEEDS = 'PERFORMANCE_UPDATE_FEEDS';
export type PERFORMANCE_UPDATE_FEEDS = typeof PERFORMANCE_UPDATE_FEEDS;

export interface UpdateFeedsAction {
    type: PERFORMANCE_UPDATE_FEEDS;
    feedsIds: string[];
    feeds: Feeds;
}

export function updateFeeds(
    feedsIds: string[],
    feeds: Feeds
): UpdateFeedsAction {
    return {
        type: PERFORMANCE_UPDATE_FEEDS,
        feedsIds,
        feeds
    };
}

export type PerformanceGroupsEditActions =
    | SetVisibleGroupBannerPopupFeedAction
    | ChangeBannerFeedSearchTextAction
    | SuggestFeedItemClickAction
    | SetVisibleFeedModalAction
    | UpdateFeedsAction;
